var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
// '#query-hooks' is imported by direct path: its barrel would close the context <-> query-hooks cycle (see CLAUDE.md).
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useUserClient } from '@lucidlink/uicore';
import { useLogOut } from '#query-hooks/mutations/account/useLogOut';
import { CurrentProfileKeyFactory } from '#query-hooks/query-key-factories';
import { useSubscribeToBroadcastMessage, } from '../../BroadcastChannel';
import { useLucidSdk } from '../../LucidSdk';
export const useHandleAuthBroadcast = () => {
    _react_refresh_temp_1();
    const { windowId } = useUserClient();
    const queryClient = useQueryClient();
    const { lucidSdk } = useLucidSdk();
    const { mutation: { mutate: logOut }, } = useLogOut({ shouldBroadcast: false });
    const restoreLogin = useCallback(async () => {
        await lucidSdk.authenticationClient().restoreLogin();
        await queryClient.resetQueries({
            queryKey: CurrentProfileKeyFactory.exact(),
            exact: true,
        });
    }, [lucidSdk, queryClient]);
    const handleLoginBroadcast = useCallback((message) => {
        if (message.type === 'login' &&
            message.payload.windowId !== windowId) {
            void restoreLogin();
        }
    }, [restoreLogin, windowId]);
    useSubscribeToBroadcastMessage({
        messageType: 'login',
        callback: handleLoginBroadcast,
    });
    const handleLogoutBroadcast = useCallback((message) => {
        if (message.type === 'logout' &&
            message.payload.windowId !== windowId) {
            logOut();
        }
    }, [logOut, windowId]);
    useSubscribeToBroadcastMessage({
        messageType: 'logout',
        callback: handleLogoutBroadcast,
    });
};
_react_refresh_temp_1(useHandleAuthBroadcast, "c+rrw2u2JwGZSStTfuA3TdOYQ2I=", false, () => [useUserClient, useQueryClient, useLucidSdk, useLogOut, useSubscribeToBroadcastMessage, useSubscribeToBroadcastMessage]);
